import React from 'react';
import PropTypes from 'prop-types';

import {Box, Divider, Stack, Typography} from 'views/components';
import {Translate, translate, MarkdownViewer} from 'views/module';

import Contacts from './contacts/Contacts';

const RelationshipView = (props) => {
  const [mouseOver, setMouseOver] = React.useState(false);

  const relationshipData = props.relationshipData;

  return (
    <Box>
      <Divider />
      <Box
        onMouseOver={() => setMouseOver(true)}
        onMouseLeave={() => setMouseOver(false)}
        sx={{
          backgroundColor: mouseOver ? 'background.highlighted' : 'inherit',
          px: 2,
          pt: 2,
          pb: 5,
        }}
      >
        <Stack
          spacing={1}
        >
          {/* Display Relationship Name */}
          <Box>
            <Typography
              sx={{
                fontWeight: 600,
              }}
            >
              <Translate expression='loomLead.LoomLeadDetail.Relationships.Details.Name' />
            </Typography>
            <Typography
              sx={{
                fontSize: '14px',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              {relationshipData.name}
            </Typography>
          </Box>
          <Box>
            {/* Display Connection Type */}
            <Typography
              sx={{
                fontWeight: 600,
              }}
            >
              <Translate expression='loomLead.LoomLeadDetail.Relationships.Details.ConnectionType' />
            </Typography>
            <Typography
              sx={{
                fontSize: '14px',
              }}
            >
              {relationshipData.connectionType}
            </Typography>
          </Box>
          <Box>
            {/* Display Priority */}
            <Typography
              sx={{
                fontWeight: 600,
              }}
            >
              <Translate expression='loomLead.LoomLeadDetail.Relationships.Details.Priority' />
            </Typography>
            <Typography
              sx={{
                fontSize: '14px',
              }}
            >
              {relationshipData.priority}
            </Typography>
          </Box>
          <Box>
            {/* Display Description */}
            <Typography
              sx={{
                fontWeight: 600,
              }}
            >
              <Translate expression='loomLead.LoomLeadDetail.Relationships.Details.Description' />
            </Typography>
            <MarkdownViewer
              value={relationshipData.description?.blob || translate('loomLead.LoomLeadDetail.Relationships.Details.NoDescription')}
              truncate
              truncateLine={8}
            />
          </Box>
          <Contacts
            relationshipData={relationshipData}
          />
        </Stack>
      </Box>
    </Box>
  );
};

RelationshipView.propTypes = {
  relationshipData: PropTypes.object.isRequired,
};

export default React.memo(RelationshipView);
